import { render, staticRenderFns } from "./xmlc.vue?vue&type=template&id=58a4651c&"
import script from "./xmlc.vue?vue&type=script&lang=js&"
export * from "./xmlc.vue?vue&type=script&lang=js&"
import style0 from "./xmlc.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports